var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SafetyHat50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fb8c00",
    d: "M31,8h-7h-7c-7,2-11,8-11,16c0,1.621,0,6,0,6h18h18c0,0,0-4.379,0-6C42,16,38,10,31,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M29,6H19c-1.105,0-2,0.895-2,2v25.3h14V8C31,6.895,30.105,6,29,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc80",
    d: "M42,24c0,0,0,5-3,5C29,29,27,16,27,9V6c0-0.552-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1v3 c0,7-2,20-12,20c-3,0-3-5-3-5l-2,2v4c0,0,0,10,20,10s20-10,20-10v-4L42,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M44 26c0 0-1 3-5 3 3-1 3-5 3-5L44 26zM4 26c0 0 1 3 5 3-3-1-3-5-3-5L4 26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M44,29c-0.025-0.025-1.835,2.818-3,4c-0.802,0.813-1.916,2.906-17,2.996 C8.916,35.906,7.802,33.813,7,33c-1.165-1.182-2.975-4.025-3-4c-0.05,0.07-1,1-1,1c0,1,1.114,5.797,2,8 c0.587,1.46,1.901,2.569,3.395,3.065C10.995,41.927,16,43,24,43s13.005-1.073,15.605-1.935C41.099,40.569,42.413,39.46,43,38 c0.886-2.203,2-7,2-8C45,30,44.05,29.07,44,29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SafetyHat50);
export default __webpack_public_path__ + "static/media/icons8-safety-hat-50.550edc7894a467827f37d2cac6795e6d.svg";
export { ForwardRef as ReactComponent };